import Navbar from "components/Navbar/Index";
import Alert from "models/Alert/alert";
import { Outlet } from "react-router-dom";
import { resetCancelOrder } from "redux/features/CancelOrder";
import { useAppDispatch, useAppSelector } from "redux/hooks";

export default function CancelOrderLayout() {
  const order_id = useAppSelector((state) => state.CancelOrder.order_id);
  const dispatch = useAppDispatch();

  return (
    <div className="flex flex-col flex-grow h-screen gap-2.5 font-inter p-3">
      <Navbar className="rounded-lg">
        <h3 className="text-[18px] font-bold text-black-label leading-[140%] tracking-[2%]">
          Cancel Order
        </h3>
        {!order_id && (
          <Alert
            handleSubmit={() => {
              dispatch(resetCancelOrder());
              window.location.href = "/remit/orders";
            }}
            actionText="cancel"
            actionButtonText="Confirm"
          >
            <button className="rounded-lg py-[11px] px-4 border bg-gray-button-gray-lite border-gray-border-gray-lite">
              Cancel
            </button>
          </Alert>
        )}
      </Navbar>
      <div className="flex-1 sm:flex-col overflow-hidden flex w-full rounded-lg">
        <Outlet />
      </div>
    </div>
  );
}
